<template>
  <div class="content work_flow_wrap">
    <!-- 筛选区（SearchBar 组件，样式基准 productInformation） -->
    <search-bar
      v-model="query"
      :conditions="conditions"
      @search="search"
      @reset="reset"
      @height-change="recalcLayout"
    ></search-bar>
    <div class="button-area">
      <el-button size="mini" type="info" @click="openDialog()">新建</el-button>
    </div>

    <!-- 列表（分页入内容盒，高度按 tableBox 顶部锚点实测） -->
    <div class="back-color-fff content-main-box" ref="tableBox" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (query.pageIndex - 1) * query.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
      <el-table-column prop="datasetName" label="数据集名称" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="dataModalName" label="数据模态" width="100"></el-table-column>
      <el-table-column label="数据总量" width="130">
        <template slot-scope="scope">{{ scope.row.dataAmount }}{{ scope.row.dataUnit }}</template>
      </el-table-column>
      <el-table-column label="来源类型" width="90">
        <template slot-scope="scope">{{ scope.row.sourceType === "1" ? "文件" : "网址" }}</template>
      </el-table-column>
      <el-table-column label="数据状态" width="110">
        <template slot-scope="scope">
          <!-- 2026-10-08 样式反馈：状态标签按状态着色（待标注黄/进行中蓝/已完结绿，色值对齐审批状态标签） -->
          <span :class="['ds-tag', statusMeta[scope.row.dataStatus] || '']">
            {{ statusText[scope.row.dataStatus] || scope.row.dataStatus }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" width="90"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.dataStatus === 'N'">
            <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
            <el-button type="text" class="danger" @click="onDelete(scope.row)">删除</el-button>
          </template>
          <el-button v-else type="text" @click="viewRow(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      </el-table>

      <el-pagination
        ref="pager"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="query.pageIndex"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新建/编辑/查看 弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="640px"
      :close-on-click-modal="false"
    >
      <!-- 2026-10-08 样式反馈：查看态改纯文本详情（原 disabled 表单伪装详情，灰底浅字被圈注）；
           编辑/新建态保持原表单，不再绑 :disabled -->
      <el-form v-if="!viewMode" :model="form" label-width="110px">
        <el-form-item label="数据集名称:" required>
          <el-input v-model="form.datasetName" maxlength="50" show-word-limit placeholder="请输入，最多50个字"></el-input>
        </el-form-item>
        <el-form-item label="数据模态:" required>
          <el-select v-model="form.dataModalGuid" placeholder="请选择" class="w100f" @change="onModalChange">
            <el-option v-for="m in modalOptions" :key="m.guid" :label="m.dicName" :value="m.guid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据总量:">
          <div class="amount-group">
            <!-- FOUR-3031 终版（方案拍板）：数据总量一律只读不允许输入——附件来源按附件拆分条目数自动计算
                 （CSV 首行标题行不计），网址来源按链接内容自动计算（直链文本文件拆条，其他链接计 1 条）；
                 单位收窄为 例/条（网址型固定"条"） -->
            <el-input v-model="form.dataAmount" readonly
              :placeholder="form.sourceType === '1' ? '按附件拆分条目数自动计算' : '按链接内容自动计算'"
              class="amount-input">
            </el-input>
            <el-select v-model="form.dataUnit" class="amount-unit" :disabled="form.sourceType === '2'" @change="onUnitChange">
              <el-option label="例" value="例"></el-option>
              <el-option label="条" value="条"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="来源类型:" required>
          <el-radio-group v-model="form.sourceType" @change="onSourceTypeChange">
            <el-radio label="1">文件</el-radio>
            <el-radio label="2">网址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.sourceType === '1'" label="文件上传:" required>
          <!-- 附件上传通用组件（obs 直传+通用样式）；accept 按数据模态白名单动态限制（产品 04 界面设计 01 sheet 注意事项） -->
          <common-upload v-model="form.fileList" :view-mode="viewMode" :accept="uploadAccept" :tip="uploadTip" />
        </el-form-item>
        <el-form-item v-if="form.sourceType === '2'" label="网址:" required>
          <el-input v-model="form.dataUrl" maxlength="500" placeholder="请输入数据地址"></el-input>
        </el-form-item>
      </el-form>
      <!-- 查看态：纯文本详情（值文字 #212121，文件行=图标+文件名+查看/下载 同行） -->
      <div v-else class="ds-detail">
        <div class="ds-detail-row">
          <div class="ds-detail-item">
            <div class="ds-detail-label">数据集名称</div>
            <div class="ds-detail-value">{{ form.datasetName || "-" }}</div>
          </div>
          <div class="ds-detail-item">
            <div class="ds-detail-label">数据模态</div>
            <div class="ds-detail-value">{{ form.dataModalName || "-" }}</div>
          </div>
        </div>
        <div class="ds-detail-row">
          <div class="ds-detail-item">
            <div class="ds-detail-label">数据总量</div>
            <div class="ds-detail-value">
              {{ form.dataAmount !== undefined && form.dataAmount !== null && form.dataAmount !== "" ? form.dataAmount + (form.dataUnit || "") : "-" }}
            </div>
          </div>
          <div class="ds-detail-item">
            <div class="ds-detail-label">来源类型</div>
            <div class="ds-detail-value">{{ form.sourceType === "1" ? "文件" : form.sourceType === "2" ? "网址" : "-" }}</div>
          </div>
        </div>
        <div class="ds-detail-row" v-if="form.sourceType === '1'">
          <div class="ds-detail-item ds-detail-item--full">
            <div class="ds-detail-label">文件上传</div>
            <ul class="ds-file-list" v-if="(form.fileList || []).length">
              <li v-for="f in form.fileList" :key="f.filePath" class="ds-file-item">
                <i class="el-icon-document"></i>
                <span class="ds-file-name" :title="f.fileName">{{ f.fileName }}</span>
                <span class="ds-file-act" @click="onPreviewFile(f)">查看</span>
                <span class="ds-file-act" @click="onDownloadFile(f)">下载</span>
              </li>
            </ul>
            <div v-else class="ds-detail-value">-</div>
          </div>
        </div>
        <div class="ds-detail-row" v-else>
          <div class="ds-detail-item ds-detail-item--full">
            <div class="ds-detail-label">网址</div>
            <div class="ds-detail-value">{{ form.dataUrl || "-" }}</div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button v-if="!viewMode" @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!viewMode" type="primary" :loading="submitting" @click="onSave">保存</el-button>
        <!-- 2026-10-08 样式反馈：关闭按钮灰边框+文字 #212121（全局 default 按钮 teal 描边，需 !important 反杀） -->
        <el-button v-else class="plain-close-btn" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonUpload from "@/components/CommonUpload/index.vue";
import SearchBar from "@/components/SearchBar";

export default {
  name: "labelDatasetManage",
  components: { CommonUpload, SearchBar },
  data() {
    return {
      // 引导估值：el-table 以 0 起步再在 mounted 里改值会丢高度更新（表格压成 0），先给非 0 初值，挂载后 recalcLayout 实测校正
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 250,
      modalOptions: [],
      statusText: {
        N: "待标注",
        D: "任务下发中",
        L: "标注中",
        Q: "质检中",
        Y: "已完结",
      },
      // 2026-10-08 样式反馈：状态标签着色映射。黄/绿为全系统审批状态标签标准色（字色+浅底+同系描边）；
      // "进行中蓝"产品拍板（10-09）：用 UI 组件默认蓝 Element primary #409EFF，终版口径
      statusMeta: {
        N: "st-wait",
        D: "st-doing",
        L: "st-doing",
        Q: "st-doing",
        Y: "st-done",
      },
      query: {
        datasetName: "",
        dataModalGuid: "",
        dataStatus: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      tableLoading: false,
      dialogVisible: false,
      submitting: false,
      viewMode: false,
      form: {},
    };
  },
  computed: {
    // 模态 → 附件扩展名白名单（与后端 save 校验同口径；MRI/CT=超声同 dcm 为 2026-09-20 产品口径）
    modalAccepts() {
      return {
        "文本": ["txt", "jsonl", "csv"],
        "音频": ["wav", "mp3"],
        "超声": ["dcm"],
        "MRI": ["dcm"],
        "CT": ["dcm"],
        "病理": ["svs", "tiff", "ndpi"],
      };
    },
    uploadAccept() {
      const exts = this.modalAccepts[this.form.dataModalName];
      return exts ? exts.map((e) => "." + e).join(",") : "";
    },
    uploadTip() {
      const exts = this.modalAccepts[this.form.dataModalName];
      return exts ? `支持多个文件，${this.form.dataModalName}模态支持 ${exts.join("/")}` : "请先选择数据模态";
    },
    // 筛选条件配置（SearchBar 统一渲染：label 无冒号定宽居中）；字典接口字段为 dicName/guid
    conditions() {
      return [
        { key: "datasetName", label: "数据集名称", type: "input" },
        {
          key: "dataModalGuid",
          label: "数据模态",
          type: "select",
          options: this.modalOptions,
          optLabel: "dicName",
          optValue: "guid",
        },
        {
          key: "dataStatus",
          label: "数据状态",
          type: "select",
          options: Object.keys(this.statusText).map((code) => ({ label: this.statusText[code], value: code })),
        },
      ];
    },
    // 例/条为整数，GB/TB 保留两位小数
    isIntUnit() {
      return this.form.dataUnit === "例" || this.form.dataUnit === "条";
    },
    dialogTitle() {
      if (this.viewMode) return "查看数据集";
      return this.form.guid ? "编辑数据集" : "新建数据集";
    },
  },
  mounted() {
    this.recalcLayout();
    window.addEventListener("resize", this.recalcLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcLayout);
  },
  created() {
    this.getModalOptions();
    this.search();
  },
  methods: {
    // 高度锚点实测：以内容盒顶部为锚，免去 header/条件行等魔法数；底部留 8px；取整避免小数像素
    recalcLayout() {
      if (!this.$refs.tableBox) return;
      const top = this.$refs.tableBox.getBoundingClientRect().top;
      this.contentMainHeight = Math.floor(window.innerHeight - top - 8);
      this.tableHeight = Math.floor(this.contentMainHeight - this.$refs.pager.$el.offsetHeight - 2);
      // 兜底：el-table 的 height watcher 有首帧丢更新场景（prop 已变而内部 layout 不动），nextTick 强制重设一次，已一致时幂等
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.layout.setHeight(this.tableHeight);
      });
    },
    formatTime(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    // 数据模态字典（文本/特征/影像/信号）
    getModalOptions() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=数据模态`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            const tree = res.data.data || [];
            // 返回可能是 [数据模态父项 childList] 或直接子项列表，兼容两种结构
            const parent = tree.find((item) => item.childList && item.childList.length);
            this.modalOptions = parent && parent.dicName === "数据模态" ? parent.childList : tree;
            this.setDefaultModal();
          }
        });
    },
    setDefaultModal() {
      // FOUR-3068：新建默认选中字典中的文本，兼容字典延迟返回并保留已有选择。
      if (!this.dialogVisible || this.viewMode || this.form.guid || this.form.dataModalGuid) return;
      const textModal = this.modalOptions.find((item) => item.dicName === "文本");
      if (textModal && textModal.guid) {
        this.form.dataModalGuid = textModal.guid;
        this.onModalChange(textModal.guid);
      }
    },
    onModalChange(guid) {
      const hit = this.modalOptions.find((item) => item.guid === guid);
      this.form.dataModalName = hit ? hit.dicName : "";
      // 模态切换后白名单变化，清掉不再合规的已选附件（后端 save 校验为最终防线）
      const exts = this.modalAccepts[this.form.dataModalName] || [];
      if (exts.length) {
        this.form.fileList = (this.form.fileList || []).filter((f) => {
          const name = f.fileName || "";
          const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
          return exts.includes(ext);
        });
      }
    },
    onUnitChange() {
      // 切到例/条时抹掉小数
      if (this.isIntUnit && this.form.dataAmount != null) {
        this.form.dataAmount = Math.floor(this.form.dataAmount);
      }
    },
    // FOUR-2988：数据总量输入拦截——非数字字符、第二个小数点、超 16 位整数、超 2 位小数即时无效
    onSourceTypeChange() {
      // 切换来源时清理另一侧数据
      if (this.form.sourceType === "1") {
        this.form.dataUrl = "";
        // 附件型：数据总量清空待自动计算；存量 GB/TB 单位回落"例"（单位已收窄为例/条）
        this.form.dataAmount = "";
        if (!this.isIntUnit) this.form.dataUnit = "例";
      } else {
        this.form.fileList = [];
        // FOUR-3031 终版：网址型按链接内容自动计算（直链文本拆条/其他 1 条），单位固定"条"
        this.form.dataAmount = "";
        this.form.dataUnit = "条";
      }
    },
    search() {
      this.tableLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-dataset/page-list`, this.query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableData = res.data.data.records || [];
            // 分页总数字段为 totalRows（同 FOUR-2966：读 total 恒 undefined 兜底 0 致"共 0 条"）
            this.total = res.data.data.totalRows || res.data.data.total || 0;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.query = {
        datasetName: "",
        dataModalGuid: "",
        dataStatus: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      };
      this.search();
    },
    pageChange(page) {
      this.query.pageIndex = page;
      this.search();
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.search();
    },
    openDialog(row) {
      this.viewMode = false;
      if (row && row.guid) {
        // 编辑回显（含文件明细）
        this.api
          .get(`/${serverConfig.msSalesPerformService}/label-dataset/edit-detail?guid=${row.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.form = {
                ...res.data.data,
                fileList: res.data.data.fileList || [],
              };
              this.dialogVisible = true;
            } else {
              this.$message.error(res.data.msg || "获取详情失败");
            }
          });
      } else {
        this.form = {
          guid: "",
          tenantGuid: localStorage.guid,
          datasetName: "",
          dataModalGuid: "",
          dataModalName: "",
          dataAmount: undefined,
          dataUnit: "例",
          sourceType: "1",
          dataUrl: "",
          fileList: [],
        };
        this.dialogVisible = true;
        this.setDefaultModal();
      }
    },
    viewRow(row) {
      this.viewMode = true;
      this.api
        .get(`/${serverConfig.msSalesPerformService}/label-dataset/edit-detail?guid=${row.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.form = {
              ...res.data.data,
              fileList: res.data.data.fileList || [],
            };
            this.dialogVisible = true;
          }
        });
    },
    checkForm() {
      if (!this.form.datasetName || !this.form.datasetName.trim()) return "请输入数据集名称";
      if (this.form.datasetName.trim().length > 50) return "数据集名称不超过50个字";
      if (!this.form.dataModalGuid) return "请选择数据模态";
      // FOUR-3031 终版：数据总量一律只读自动计算（附件=拆分条目数/网址=1条），不再做输入校验
      if (this.form.sourceType === "1" && (!this.form.fileList || !this.form.fileList.length)) {
        return "来源类型为文件时须上传文件";
      }
      if (this.form.sourceType === "2" && !this.form.dataUrl) return "请输入网址";
      // 缺协议头会在任务链路消费方构造 URI 时秒败，被"无法访问"类网络文案掩盖，前置拦截
      if (this.form.sourceType === "2" && !/^https?:\/\//.test(this.form.dataUrl.trim())) {
        return "网址须以 http:// 或 https:// 开头";
      }
      return "";
    },
    onSave() {
      const errMsg = this.checkForm();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      this.submitting = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-dataset/save`, this.form)
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.search();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    // 查看态详情文件行操作（规则同 CommonUpload：图片/pdf/压缩包新窗口直开，office 走在线预览）
    onPreviewFile(file) {
      const name = file.fileName || "";
      const suffix = name.substring(name.lastIndexOf(".") + 1);
      if (["png", "jpeg", "jpg", "pdf", "zip", "rar"].includes(suffix)) {
        return window.open(file.filePath);
      }
      window.open("https://view.officeapps.live.com/op/view.aspx?src=" + file.filePath);
    },
    onDownloadFile(file) {
      window.open(file.filePath + "?response-content-type=application/octet-stream");
    },
    onDelete(row) {
      this.$confirm("确定删除该数据集吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/label-dataset/delete?guid=${row.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
      });
    },
  },
};
</script>

<style scoped>
/* 2026-10-08 样式反馈：数据状态三色标签（黄/绿=审批状态标准色；蓝无审批基准暂用 Element primary） */
/* 2026-10-10 样式反馈：标签宽度统一为"任务下发中"宽度（78px=5字12px+左右8padding+2边框）且文字居中，
   原内容自适应宽导致 3 字标签窄、文字贴左 */
.ds-tag {
  display: inline-block;
  width: 78px;
  box-sizing: border-box;
  text-align: center;
  height: 22px;
  line-height: 20px;
  padding: 0 8px;
  border-radius: 2px;
  font-size: 12px;
}
.ds-tag.st-wait {
  color: #ff991c;
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
}
.ds-tag.st-doing {
  color: #409eff;
  background: #f0f7ff;
  border: 1px solid rgba(212, 232, 248, 1);
}
.ds-tag.st-done {
  color: #1ba854;
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
}
/* 2026-10-08 样式反馈：查看数据集弹窗纯文本详情（值文字 #212121；文件行=图标+文件名+操作同行） */
.ds-detail {
  text-align: left;
}
.ds-detail-row {
  display: flex;
}
.ds-detail-item {
  width: 50%;
  box-sizing: border-box;
  padding: 0 12px;
  margin-bottom: 16px;
}
.ds-detail-item--full {
  width: 100%;
}
.ds-detail-label {
  color: #909399;
  font-size: 13px;
  margin-bottom: 6px;
}
.ds-detail-value {
  color: #212121;
  font-size: 14px;
  word-break: break-all;
}
.ds-file-list {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 210px;
  overflow-y: auto;
}
.ds-file-item {
  display: flex;
  align-items: center;
  line-height: 26px;
  font-size: 14px;
  color: #212121;
  white-space: nowrap;
}
.ds-file-item i {
  color: #909399;
  margin-right: 6px;
}
.ds-file-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ds-file-act {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #4fa1a4;
  flex-shrink: 0;
}
/* 关闭按钮：灰边框+文字 #212121（全局 default 按钮 teal 描边为无 !important 规则，此处反杀含 hover/focus） */
.plain-close-btn {
  border: 1px solid #d9d9d9 !important;
  color: #212121 !important;
  background: #fff !important;
}
.plain-close-btn:hover,
.plain-close-btn:focus {
  border: 1px solid #c0c4cc !important;
  color: #212121 !important;
  background: #fff !important;
}
/* 弹框表单整体靠左（抵御 #app 全局 text-align:center 居中坑，"文件/网址"单选组等） */
.content /deep/ .el-dialog .el-form {
  text-align: left;
}
/* 附件上传的文件行样式已封装进 components/CommonUpload（触发区样式走全局 style.css） */
.danger {
  color: #f56c6c;
}
/* 操作列竖线分隔（对齐 certAuditManage 定的标准，FOUR-2958① 同款）：紧凑间距、竖线继承 teal；限表格内防误伤弹框按钮 */
.content /deep/ .el-table .el-button + .el-button {
  margin-left: 4px;
}
.content /deep/ .el-table .el-button + .el-button::before {
  content: "|";
  display: inline-block;
  margin-right: 4px;
  color: #4fa1a4 !important;
}
.w100f {
  width: 100%;
}
.amount-group {
  display: flex;
  gap: 8px;
}
.amount-input {
  flex: 1;
}
.amount-input /deep/ .el-input__inner {
  text-align: left;
}
.amount-unit {
  width: 90px;
}
</style>
